module.exports = __webpack_public_path__ + "static/media/dr-sampath-old.59840277.jpg";